import { getReportAuthorEmail } from "./reportAuthor";
import {
	getReportAuthorName,
	getReportPlaceParts,
	getStreamRecordId,
	getStreamRecordLabel,
	getStreamRecordName,
	StreamPlaceReport,
	StreamPlaces,
} from "./reportStream";

// The fields of an MoC the MoC stream reads.
export type StreamMoc = StreamPlaceReport & {
	report_number?: unknown;
	title?: unknown;
	description?: unknown;
	// The category's id, as the report form stores it.
	category?: unknown;
	operator?: string;
	primary_author?: string | null;
	author?: string | null;
};

// The MoC's category, when it is stored as an id.
export const getMocCategoryId = (report: StreamMoc) =>
	getStreamRecordId(report.category);

// A category's name, when it is known. Only ids are looked up, so other text
// never reads an object's own keys.
export const getMocCategoryName = (
	id: string | undefined,
	categoryMap: Record<string, any>
) => getStreamRecordName(categoryMap, id);

// How the category filter names a category: by its name, or as an unknown
// category while the categories load, or for one deleted or in a tenant the
// user can't read.
export const getMocCategoryLabel = (
	id: string,
	categoryMap: Record<string, any>
) => getStreamRecordLabel(categoryMap, id, "Unknown category");

// The line under an MoC's title: its category, then where it belongs.
export const getMocMeta = (
	report: StreamMoc,
	places: StreamPlaces,
	categoryMap: Record<string, any>
) => ({
	tag: getMocCategoryName(getMocCategoryId(report), categoryMap),
	parts: getReportPlaceParts(report, places),
});

// What the stream's search looks through for an MoC.
export function getMocSearchTexts(
	report: StreamMoc,
	places: StreamPlaces,
	categoryMap: Record<string, any>,
	authorNames: Record<string, string>,
	getTenantName: (tenantKey: string) => string | undefined
) {
	const { tag, parts } = getMocMeta(report, places, categoryMap);
	return [
		report.report_number,
		report.title,
		report.description,
		tag,
		...parts,
		getReportAuthorEmail(report),
		getReportAuthorName(report, authorNames),
		report.operator ? getTenantName(report.operator) : undefined,
	];
}
